export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=708867cc6345d95d4db35110b16ee9d1f5de39bceb&name=pushAdClickData!'